<template>
  <section class="silider-section">
    <div class="cardEspecial">
      <div class="card-content">
        <carousel ref="micarousel" :perPageCustom="responsiveArray" @navigation-click="handlePageChange"
          :navigationEnabled="true" :paginationEnabled="false" navigationNextLabel="<img src='/assets/img/next.png' />"
          navigationPrevLabel="<img src='/assets/img/prev.png' />">
          <slide v-for="(item, index) in items" :key="item.key">
            <mvideo from="slider" :config="item" :index=index v-if="item.entrada == 'R' || item.entrada == 'T'"
              @goToNote="goToNote" @goToNotes="goToNotes" @notFound="notFound"></mvideo>
            <youtube-note from="slider" :config="item" v-if="item.entrada == 'Y'" @goToNotes="goToNotes"
              @goToNote="goToNote"></youtube-note>
            <text-note from="slider" :config="item"
              v-if="item.entrada == 'TW' || item.entrada == 'FB' || item.entrada == 'PD' || item.entrada == 'I' || item.entrada == 'TK'"
              @goToNote="goToNote" @goToNotes="goToNotes"></text-note>
          </slide>
        </carousel>
      </div>
    </div>
  </section>
</template>


<script>
import moment from "moment-timezone";

import { Carousel, Slide } from "vue-carousel";
import mvideo from "@/components/mvideo";
import textNote from "@/components/textNote";
import youtubeNote from "@/components/youtubeNote";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";

library.add(faChevronRight);
library.add(faChevronLeft);

export default {
  name: "sliderVideoNotes",
  props: ["items", "fi", "keyNota"],
  components: {
    Carousel,
    Slide,
    mvideo,
    textNote,
    youtubeNote
  },
  data() {
    return {
      classCard: "card",
      itemsPerPage: 2,
      next: "<img src='/assets/img/next.png' />",
      prev: "<img src='/assets/img/next.png' />",
      responsiveArray: [],
      parsedData:null
    };
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  beforeMount() {
    switch (this.fi) {
      case "T":
        this.responsiveArray = [
          [480, 2],
          [768, 4],
          [1024, 5],
          [1440, 8],
          [1600, 9]
        ];
        break;
      case "R":
        this.responsiveArray = [
          [480, 2],
          [768, 4],
          [1024, 5],
          [1440, 8],
          [1600, 9]
        ];

        break;
      case "TW":
        this.responsiveArray = [
          [320, 1],
          [480, 2],
          [768, 3],
          [1024, 4],
          [1140, 5],
          [1445, 6],
          [1600, 9]
        ];
        break;
      case "FB":
        this.responsiveArray = [
          [320, 1],
          [480, 2],
          [768, 3],
          [1024, 4],
          [1140, 5],
          [1445, 6],
          [1600, 8]
        ];

        break;
      case "Y":
        this.responsiveArray = [
          [480, 2],
          [768, 3],
          [1024, 5],
          [1140, 6],
          [1440, 9],
          [1600, 9]
        ];
        break;
      case "PD":
        this.responsiveArray = [
          [320, 1],
          [480, 2],
          [768, 3],
          [1024, 4],
          [1140, 5],
          [1445, 6],
          [1600, 8]
        ];
        break;
      case "I":
        this.responsiveArray = [
          [320, 1],
          [480, 2],
          [768, 3],
          [1024, 4],
          [1140, 5],
          [1445, 6],
          [1600, 8]
        ];
        break;
      case "TK":
        this.responsiveArray = [
          [320, 1],
          [480, 2],
          [768, 3],
          [1024, 4],
          [1140, 5],
          [1445, 6],
          [1600, 8]
        ];
        break;
    }

    this.handleResize();
  },
  sockets: {
    onmessage(data) {
      this.handleIncomingMessage(data.data);
    },
  },
  methods: {
    handleIncomingMessage(data) {
      try {
          let parsedData = JSON.parse(data);
        if (this.isValidNota(parsedData)) {
            switch (parsedData.entrada) {
            case "T":
            case "R":
            this.agregaNotasOffWss(parsedData);
              break;
            case "PD":
            this.agregaNotasOffPDWss(parsedData);
              break;
            case "FB":
            case "TW":
            case "Y":
            case "I":
            this.agregaNotasONWss(parsedData);
            break;
            case "TK":
            this.agregaNotasTitktok(parsedData);
              break;
          }
          
        } else {
          console.warn('Datos no válidos recibidos:', parsedData);
        }
      } catch (e) {
        // Registro del error y datos para depuración
        console.error('Error al analizar los datos recibidos:', data, e);
      }
    },
    isValidNota(data) {
      if (
        data
      ) {
        return true;
      }
      return false;
    },
    agregaNotasOffWss(data) {
      let condigo = this.keyNota;
      let codigoNota = data.codigo_noticiero;
      if(condigo == codigoNota){
        this.$emit("goToWss", data);
      }
    },
    agregaNotasOffPDWss(data) {
      let condigo = this.keyNota;
      let codigoNota = data.key_src;
      if(condigo == codigoNota){
        this.$emit("goToWss", data);
      }
    },
    agregaNotasONWss(data) {
      let condigo = this.keyNota;
      let codigoNota = data.key_src;
      if(condigo == codigoNota){
        this.$emit("goToWss", data);
      }
    },
    agregaNotasTitktok(data) {
      var self = this;
      let condigo = this.keyNota;
      let codigoNota = data.autor;
      if(condigo == codigoNota){
        self.items = [].concat(data,self.items)
      }
      
    },
    handlePageChange(page) {
      //  var paginaFinal = parseInt(this.items.length / this.itemsPerPage);

      if (page == "forward") {
        //llegamos al final?
        this.$emit("loadMore", this.items); //pedimos más items
      }
    },
    goToNote(params) {
      this.$emit("goToNote", params);
    },
    goToNotes(params) {
      this.$emit("goToNotes", params);
    },
    handleResize() {
      var width = window.innerWidth;
      /**  var responsiveArray =
        this.responsiveArray[0][0] == 480
          ? this.responsiveArray.reverse()
          : this.responsiveArray; **/
      for (var i = 0; i < this.responsiveArray.length; i++) {
        var arr = this.responsiveArray[i];
        if (width >= arr[0]) {
          this.itemsPerPage = arr[1];
        }
      }
    },
    notFound(index) {
      this.items.splice(index, 1);
    }
  }
};
</script>
<style scoped>
@keyframes blink {
  0% {
        color: white;
    }
    50% {
        color: #3fe6cd;
    }
    100% {
        color: #00b99e;
    }
}

.blink {
    animation: blink 2s infinite;
}
.hora-r {
    /* Estilos para cuando item.entrada es 'R' 
    color: red;*/
}
</style>
<style>
.VueCarousel-navigation-button img {
  width: 10px;
}

.VueCarousel-navigation-button {
  padding: 0px;
}
</style>
<style scoped>
.silider-section {
  padding: 10px 0;
}

.cardEspecial {
  background-color: none;
}

.folder-name {
  color: #00b99e !important;
}

.touchpad {
  cursor: pointer;
}

.img-avatar {
  height: 100%;
}

.folder .folder-image {
  border: solid 6px #ebf9ff;
  /*00B99E*/
  color: #00b99e;
}

.folder .folder-image:hover {
  background: #ebf9ff;
}

.folder-image .img-avatar {
  position: relative;
}

.folder-image .middle {
  height: auto;
  display: block;
  position: relative;
  transition: 0.5s ease;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  text-align: center;
}

.text {
  width: 100%;
  font-size: 16px;
}

.VueCarousel-slide {
  padding: 0px 5px;
}
</style>